export default [
    {
      title: 'menu.Cancellations',
      icon: 'FileMinusIcon',
      tagVariant: 'light-danger',
      route:'cancellations'
    },
  ]
  